const ru = {
    translation: {
        // Trucks 
        title: "Грузовики",
        intro: {
        main_text: "Гарантия вашего успеха",
        text_1: "В MMSH Logistics мы понимаем, что спрос на надежные и эффективные услуги автомобильных перевозок остается стабильно высоким по всему миру. Наши услуги транспортировки грузовиками позволяют гибко планировать график перевозок, независимо от портов, аэропортов или железнодорожных станций. Перед тем как предложить индивидуальное решение и составить оптимальный маршрут, наша опытная команда логистов тщательно анализирует каждую заявку. Мы гордимся тем, что уважаем время наших клиентов, поэтому используем новейшие технологии GPS и ГЛОНАСС для отслеживания отправлений."
        },

        more_info: "Дополнительная информация",

        projects: {
        title: "Завершенные проекты",
        items: [
            { title: "Глобальная нехватка водителей." },
            { title: "Цифровые решения для вашей помощи." },
            { title: "Новые морские маршруты перевозок." },
            { title: "Последствия землетрясений в Турции." }
        ]
        },

        completed_projects: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Новый порт готов к обслуживанию клиентов." },
            { title: "Гарантия стабильности бизнеса." },
            { title: "Наши суда начали работать с США." }
        ]
        },
        // Trucks
        // Trains
        title_2: "Поезда",
        intro_2: {
        main_text_2: "Быстрая доставка с железнодорожными грузоперевозками",
        text_1: "В MMSH Logistics мы осознаем растущий спрос на быстрые, экономически выгодные и экологически чистые решения в области железнодорожных перевозок. Наши железнодорожные транспортные услуги обеспечивают бесперебойные и высокоемкие перевозки на большие расстояния, гарантируя эффективность и устойчивость. Перед разработкой индивидуального логистического плана наша экспертная команда тщательно оценивает каждую заявку, оптимизируя маршруты для максимальной скорости и экономии затрат. Используя передовые технологии отслеживания, такие как GPS и ГЛОНАСС, мы предоставляем клиентам возможность следить за отправлением в реальном времени, обеспечивая уверенность на каждом этапе пути."
        },

        projects_2: {
        title: "Завершенные проекты",
        items: [
            { title: "Цифровизация наших услуг." },
            { title: "Расширение торговли с Европой." },
            { title: "Новые поезда из Японии готовы к эксплуатации." },
            { title: "Рост заработных плат для наших сотрудников." }
        ]
        },

        completed_projects_2: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Открытие нашего нового офиса в Огайо." },
            { title: "Теперь доставка грузов стала быстрее." },
            { title: "Укрепление торговых связей с Пекином." },
            { title: "Используйте наше новое мобильное приложение для логистики." }
        ]
        },
        // Trains
        // Air
        title_3: "Авиация",
        intro_3: {
        main_text_3: "Быстрые и надежные авиационные грузоперевозки",
        text_1: "Благодаря доступу к широкой сети международных авиаперевозчиков, мы предлагаем гибкое расписание, приоритетную обработку и индивидуальные логистические решения для бизнеса любого масштаба. Независимо от того, требуется ли срочная доставка, перевозка ценных грузов или термочувствительных товаров, мы гарантируем, что они будут транспортированы в соответствии с высочайшими стандартами безопасности и заботы. Интегрируя технологии отслеживания в реальном времени, такие как GPS и современные логистические системы, мы обеспечиваем полную прозрачность перемещения груза с момента отправки до прибытия. Наша преданная команда оптимизирует маршруты для максимальной эффективности и экономии затрат, предоставляя безупречный опыт авиационных грузоперевозок. С MMSH Logistics мир у вас под рукой. Когда важна скорость, мы доставляем."
        },

        projects_3: {
        title: "Завершенные проекты",
        items: [
            { title: "Надежное партнерство с MMSH." },
            { title: "Самая быстрая доставка на другие континенты." },
            { title: "Доступные и оперативные авиаперевозки." }
        ]
        },

        completed_projects_3: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Партнерство с международными компаниями." },
            { title: "Мы начали сотрудничество с Южной Америкой." }
        ]
        },
        // Air
        // Boats
        title_4: "Суда",
        intro_4: {
        main_text_4: "Бесперебойные и надежные морские грузоперевозки",
        text_1: "Благодаря доступу к широкой глобальной сети судоходных перевозчиков и портов, мы предоставляем гибкое расписание, безопасную обработку и индивидуальные логистические решения для бизнеса любого масштаба. Независимо от того, перевозите ли вы массовые грузы, негабаритное оборудование или термочувствительные товары, мы гарантируем безопасную и эффективную морскую транспортировку через международные воды. Используя передовые технологии отслеживания, включая GPS, AIS (Автоматическую систему идентификации) и спутниковый мониторинг, мы обеспечиваем видимость груза в реальном времени от порта до порта. Наша команда специалистов оптимизирует маршруты, минимизируя время в пути и снижая затраты, обеспечивая бесперебойные и своевременные поставки."
        },

        projects_4: {
        title: "Завершенные проекты",
        items: [
            { title: "Открытие новых портов для торговли." },
            { title: "Развитие регламентированных программ безопасности." },
            { title: "Комфортные перевозки по морю." }
        ]
        },

        completed_projects_4: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Установление партнерства с портом в Гонконге." },
            { title: "Быстрая транспортировка с MMSH." }
        ]
        },
        // Boats
        // Multimodal
        title_5: "Мультимодальные перевозки",
        intro_5: {
        main_text_5: "Интегрированные и эффективные мультимодальные логистические решения",
        text_1: "Объединяя преимущества воздушного, морского, автомобильного и железнодорожного транспорта, мы предлагаем бесшовные мультимодальные логистические решения, адаптированные к вашим бизнес-потребностям. Наши гибкие графики и безопасное управление грузами обеспечивают эффективное перемещение товаров через границы и континенты. Будь то контейнерные грузы, негабаритное оборудование или термочувствительные поставки, мы оптимизируем маршруты, минимизируя время в пути и затраты. Используя передовые технологии отслеживания, включая GPS, AIS и спутниковый мониторинг, мы обеспечиваем видимость груза в реальном времени на каждом этапе пути. Наша команда экспертов координирует различные виды транспорта для своевременной и экономически эффективной доставки."
        },

        projects_5: {
        title: "Завершенные проекты",
        items: [
            { title: "Расширение наших глобальных торговых маршрутов." },
            { title: "Внедрение систем, управляемых искусственным интеллектом." },
            { title: "Оптимизация мультимодальных грузоперевозок." },
            { title: "Развитие устойчивых логистических практик." }
        ]
        },

        completed_projects_5: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Стратегический альянс с портом в Гонконге." },
            { title: "Более быстрая логистика с MMSH Express Service." }
        ]
        },
        // Multimodal
        // Chemicals
        title_6: "Химическая продукция",
        intro_6: {
        main_text_6: "Безопасная, эффективная и соответствующая стандартам химическая логистика",
        text_1: "MMSH Logistics специализируется на безопасной и эффективной транспортировке химических грузов, обеспечивая полное соответствие международным нормам безопасности. Наши мультимодальные решения — охватывающие автомобильный, морской, железнодорожный и воздушный транспорт — обеспечивают бесшовную доставку как опасных, так и неопасных химикатов. Мы работаем с ведущими отраслевыми партнерами для обеспечения безопасной обработки, температурного контроля и специализированных методов транспортировки. Наша команда экспертов управляет всей необходимой документацией и требованиями соответствия, обеспечивая бесперебойное таможенное оформление и соблюдение нормативных требований на международных рынках. Используя передовые технологии отслеживания, мы обеспечиваем полную видимость груза по всей цепочке поставок, предлагая надежное и экономически эффективное решение для химической логистики."
        },

        projects_6: {
        title: "Прогресс в области перевозок химической продукции",
        items: [
            { title: "Глобальное расширение маршрутов перевозки химикатов." },
            { title: "Отслеживание опасных грузов с использованием ИИ." },
            { title: "Оптимизированные мультимодальные логистические решения для химической продукции." },
            { title: "Экологически чистые решения для перевозки химикатов." }
        ]
        },

        completed_projects_6: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Создание нового центра химической логистики в Европе." },
            { title: "Внедрение мониторинга безопасности на основе искусственного интеллекта." }
        ]
        },
        // Chemicals
        // Technology
        title_9: "Технологии",
        intro_9: {
        main_text_9: "Безопасная и высокоскоростная логистика для технологической отрасли",
        text_1: "MMSH Logistics предлагает индивидуальные транспортные решения для ценной технологической продукции, включая электронику, полупроводники и серверное оборудование. Мы понимаем, что технологическая отрасль требует не только быстрой доставки, но и высокоэффективных систем безопасности и климат-контроля для защиты чувствительных компонентов. Наша логистическая сеть обеспечивает безопасную обработку, мониторинг в режиме реального времени и ускоренные поставки для производства и дистрибуции в режиме just-in-time. Используя возможности искусственного интеллекта и мультимодальные решения, мы сокращаем время в пути и эксплуатационные расходы, позволяя компаниям оптимизировать эффективность цепочек поставок. Будь то экспресс-доставка по воздуху или безопасная контейнерная перевозка крупной электроники, мы предлагаем индивидуальные решения для удовлетворения ваших потребностей."
        },

        projects_9: {
        title: "Прогресс в логистике технологической продукции",
        items: [
            { title: "Расширение сети безопасных складов для электроники." },
            { title: "Использование IoT-сенсоров для отслеживания грузов в режиме реального времени." },
            { title: "Оптимизированная логистика поставок полупроводников." },
            { title: "Усовершенствованные системы безопасности для перевозки дорогостоящих товаров." }
        ]
        },

        completed_projects_9: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Создание глобальной безопасной сети логистики для полупроводников." },
            { title: "Внедрение мониторинга на основе искусственного интеллекта для отслеживания высокочувствительных грузов." }
        ]
        },
        // Technology
        // Groceries
        title_10: "Продукты питания",
        intro_10: {
        main_text_10: "Быстрая и свежая логистика для цепочек поставок продуктов питания",
        text_1: "MMSH Logistics предлагает температурно-контролируемые и оперативные транспортные решения для распределения продуктов питания. Мы специализируемся на перевозке свежих продуктов, молочных изделий, мяса, замороженных товаров и сухих пищевых продуктов, гарантируя, что скоропортящиеся продукты сохраняют свое качество от фермы до прилавка. Наша передовая логистика холодовой цепи включает климат-контролируемые склады, мониторинг температуры в режиме реального времени и сети экспресс-доставки. Независимо от того, требуется ли крупномасштабное распределение для супермаркетов или небольшие поставки для местных рынков, мы оптимизируем цепочки поставок для предотвращения порчи, сокращения отходов и повышения эффективности."
        },

        projects_10: {
        title: "Инновации в логистике продуктов питания",
        items: [
            { title: "Расширение парка рефрижераторных транспортных средств." },
            { title: "Оптимизация цепочек поставок с использованием ИИ." },
            { title: "Передовые технологии упаковки для продления срока хранения." },
            { title: "Экологически чистая логистика для органических продуктов." }
        ]
        },

        completed_projects_10: {
            title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
            items: [
              { title: "Разработана сеть температурного контроля для продуктов питания." },
              { title: "Интегрирован прогноз спроса на свежие продукты на основе ИИ." }
            ]
        },
        //Groceries
        // Pharmaceuticals
        title_11: "Фармацевтика",
        intro_11: {
        main_text_11: "Логистика с температурным контролем и соответствием стандартам для фармацевтики",
        text_1: "MMSH Logistics специализируется на транспортировке фармацевтической продукции, гарантируя безопасную и эффективную доставку термочувствительных медикаментов, вакцин и медицинских товаров. Мы используем передовые технологии холодовой цепи с мониторингом температуры в реальном времени, обеспечивая соответствие требованиям ВОЗ и GDP. Наша команда обучена бережному обращению с фармацевтическими грузами, обеспечивая безопасные транспортные решения для больниц, аптек и медицинских дистрибьюторов. От температурно-контролируемого хранения до ускоренной последней мили доставки – мы гарантируем, что критически важные медицинские товары перевозятся в оптимальных условиях, минимизируя риски и задержки."
        },

        projects_11: {
        title: "Развитие решений для фармацевтических грузоперевозок",
        items: [
            { title: "Расширение сети температурно-контролируемых складов." },
            { title: "Использование блокчейна для безопасного медицинского отслеживания." },
            { title: "Логистика на основе ИИ для транспортировки вакцин." },
            { title: "Экстренная логистика для срочных медицинских поставок." }
        ]
        },

        completed_projects_11: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Безопасное распределение вакцин по континентам." },
            { title: "Управление рисками в фармацевтической логистике на основе ИИ." }
        ]
        },
        // Pharmaceuticals

        // Fashion
        title_12: "Мода",
        intro_12: {
        main_text_12: "Быстрая и гибкая логистика для индустрии моды",
        text_1: "MMSH Logistics предлагает индивидуальные решения для перевозки товаров индустрии моды, обеспечивая своевременную и эффективную транспортировку текстиля, одежды и аксессуаров. Мы понимаем, что скорость и точность имеют решающее значение в данной отрасли, где сезонные тренды и быстро меняющиеся запросы требуют гибких логистических решений. Наша сеть включает экспресс-авиаперевозки, специализированные автоперевозки и эффективные склады, поддерживая бренды в доставке продукции на глобальные рынки точно в срок. Благодаря умному управлению запасами и прогнозированию спроса на основе ИИ мы помогаем компаниям оптимизировать цепочки поставок, минимизировать избыточные запасы и способствовать устойчивому развитию через экологически чистые транспортные решения."
        },

        projects_12: {
        title: "Развитие решений для логистики в индустрии моды",
        items: [
            { title: "Расширение международных маршрутов дистрибуции модной продукции." },
            { title: "Отслеживание грузов в реальном времени для текстильных поставок." },
            { title: "Оптимизация цепочек поставок для fast fashion." },
            { title: "Экологически чистая логистика для устойчивых брендов." }
        ]
        },

        completed_projects_12: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Экспресс-логистика для сезонных модных коллекций." },
            { title: "Прогнозирование спроса на основе ИИ для брендов одежды." }
        ]
        },
        // Fashion

        // Agricultural
        title_13: "Сельское хозяйство",
        intro_13: {
        main_text_13: "Надежная и устойчивая логистика для агропромышленного сектора",
        text_1: "MMSH Logistics специализируется на транспортировке сельскохозяйственной продукции, включая зерновые, свежие продукты, удобрения и корма для животных. Наша обширная логистическая сеть обеспечивает эффективную доставку от фермы к рынку, поддерживая производителей, оптовиков и экспортеров. Благодаря температурно-контролируемому транспорту, специализированным грузовикам для сыпучих материалов и логистике «точно в срок», мы минимизируем потери и сокращаем сроки доставки. Наш мультимодальный подход объединяет автомобильные, железнодорожные, морские и воздушные перевозки, предлагая гибкие транспортные решения для сезонных культур и скоропортящихся товаров. Используя прогнозирование спроса на основе ИИ и технологию блокчейн, мы оптимизируем цепочки поставок и обеспечиваем соответствие мировым стандартам безопасности пищевых продуктов. От местных сельскохозяйственных кооперативов до крупных экспортеров MMSH Logistics предлагает инновационные и экологически чистые логистические решения, адаптированные к потребностям отрасли."
        },

        projects_13: {
        title: "Развитие логистических решений для сельского хозяйства",
        items: [
            { title: "Расширение сети холодовой цепи для скоропортящихся культур." },
            { title: "Прогнозирование запасов на основе ИИ для фермерских кооперативов." },
            { title: "Оптимизация мультимодальных перевозок для экспорта зерновых." },
            { title: "Экологически чистая упаковка для органической продукции." }
        ]
        },

        completed_projects_13: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Разработаны сети экспресс-доставки от фермы к рынку." },
            { title: "Интегрирована технология блокчейн для отслеживания цепочки поставок." }
        ]
        },
        // Agricultural

        // Construction
        title_14: "Строительство",
        intro_14: {
        main_text_14: "Мощная и эффективная логистика для строительной отрасли",
        text_1: "MMSH Logistics специализируется на транспортировке строительных материалов, включая цемент, сталь, пиломатериалы, тяжелую технику и модульные конструкции. Наши логистические решения поддерживают крупные инфраструктурные проекты, жилое строительство и коммерческие объекты, обеспечивая своевременную и экономически выгодную доставку ключевых материалов. Мы используем специализированные тяжеловесные грузовики, железнодорожные перевозки навалочных грузов и мультимодальные решения для транспортировки негабаритных и тяжелых грузов. Наши логистические специалисты координируют доставку «точно в срок», помогая строительным площадкам сократить затраты на хранение и соблюдать графики строительства. От сырьевых материалов до высокотехнологичных модульных зданий MMSH Logistics оптимизирует цепочки поставок, минимизирует задержки и обеспечивает соответствие международным нормативам."
        },

        projects_14: {
        title: "Развитие логистики в строительном секторе",
        items: [
            { title: "Расширение специализированного автопарка для тяжелых грузов." },
            { title: "Логистика на основе ИИ для доставки строительных материалов на объект." },
            { title: "Оптимизация мультимодальных перевозок для модульных конструкций." },
            { title: "Устойчивые решения для цепочек поставок строительных материалов." }
        ]
        },

        completed_projects_14: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Разработаны логистические решения «точно в срок» для крупных инфраструктурных проектов." },
            { title: "Интегрировано цифровое отслеживание для навалочных строительных материалов." }
        ]
        },
        // Construction
        // Bulk
        title_15: "Навалочные грузы",
        intro_15: {
        main_text_15: "Надежная и экономически эффективная логистика для навалочных грузов",
        text_1: "MMSH Logistics специализируется на транспортировке навалочных грузов, включая сырье, полезные ископаемые, сельскохозяйственную продукцию и промышленные товары. Наш опыт в перевозке сухих, жидких и генеральных грузов обеспечивает эффективное перемещение больших объемов по глобальным торговым маршрутам. Мы используем специализированные суда, балкеры и железнодорожные перевозки для оптимизации затрат и времени в пути. Благодаря выделенным портовым терминалам, автоматизированным системам обработки грузов и мониторингу в реальном времени мы предоставляем беспроблемные логистические решения для отраслей, требующих высокопроизводительной перевозки. Наши индивидуальные стратегии доставки навалочных грузов помогают предприятиям минимизировать расходы на хранение, оптимизировать цепочки поставок и способствовать устойчивому развитию благодаря экологически чистым методам транспортировки."
        },

        projects_15: {
        title: "Развитие логистики навалочных грузов",
        items: [
            { title: "Расширение флота балкеров для международной торговли." },
            { title: "Оптимизация погрузочно-разгрузочных операций с использованием ИИ." },
            { title: "Интеграция автоматизированной обработки навалочных грузов в портах." },
            { title: "Устойчивые логистические решения для перевозки навалочных материалов." }
        ]
        },

        completed_projects_15: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Разработаны мультимодальные решения для транспортировки навалочных грузов." },
            { title: "Интегрирован цифровой мониторинг для отслеживания грузов в реальном времени." }
        ]
        },
        // Bulk

        // Expensive Cargo
        title_16: "Дорогие грузы",
        intro_16: {
        main_text_16: "Безопасная и специализированная логистика для ценных грузов",
        text_1: "MMSH Logistics предоставляет премиальные транспортные решения для дорогостоящих и чувствительных грузов, включая предметы роскоши, ювелирные изделия, электронику, произведения искусства и финансовые активы. Мы понимаем, что безопасность, конфиденциальность и эффективность являются ключевыми при перевозке ценных товаров. Наши услуги включают бронированный транспорт, климат-контролируемое хранение и выделенное сопровождение безопасности для обеспечения максимальной защиты на всем пути следования. Используя передовые технологии отслеживания, биометрический контроль доступа и оценку рисков на основе ИИ, мы минимизируем угрозы и повышаем прозрачность транспортировки. Будь то транспортировка редких коллекционных предметов, конфиденциальных документов или элитной моды, MMSH Logistics предлагает индивидуальные решения для защиты ваших ценных активов."
        },

        projects_16: {
        title: "Развитие логистики ценных грузов",
        items: [
            { title: "Расширение сети безопасной логистики для предметов роскоши." },
            { title: "Анализ рисков на основе ИИ для перевозки дорогостоящих грузов." },
            { title: "Интеграция биометрической системы безопасности на складах." },
            { title: "Оптимизация мультимодальных перевозок для ценных товаров." }
        ]
        },

        completed_projects_16: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Созданы глобальные безопасные маршруты для транспортировки ювелирных изделий." },
            { title: "Разработаны бронированные транспортные решения для электроники." }
        ]
        },
        // Expensive Cargo

        // Heavy Cargo
        title_17: "Тяжелые грузы",
        intro_17: {
        main_text_17: "Надежная и специализированная логистика для тяжеловесных грузов",
        text_1: "MMSH Logistics предлагает индивидуальные транспортные решения для негабаритных и тяжеловесных грузов, включая промышленное оборудование, строительную технику, ветряные турбины и крупные инфраструктурные компоненты. Наш опыт в перевозке сверхтяжелых и крупногабаритных грузов гарантирует их безопасную транспортировку с высокой точностью. Мы используем специализированные низкорамные платформы, модульные транспортные системы и суда для перевозки тяжелых грузов, обеспечивая их надежную и эффективную доставку. Наши логистические стратегии включают детальный анализ маршрута, соблюдение нормативных требований и организацию сопровождения для негабаритных грузов. Будь то международные перевозки тяжелых грузов или крупномасштабные промышленные проекты, мы обеспечиваем бесперебойную, экономичную и оперативную транспортировку."
        },

        projects_17: {
        title: "Развитие логистики тяжелых грузов",
        items: [
            { title: "Расширение специализированного автопарка для тяжеловесных грузов." },
            { title: "Оптимизация маршрутов для негабаритных перевозок с использованием ИИ." },
            { title: "Интеграция системы отслеживания в реальном времени для промышленного оборудования." },
            { title: "Оптимизация логистики для крупномасштабных грузоперевозок." }
        ]
        },

        completed_projects_17: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Разработаны мультимодальные решения для транспортировки негабаритных грузов." },
            { title: "Успешно выполнены международные перевозки тяжелого промышленного оборудования." }
        ]
        },
        // Heavy Cargo

        // Liquid Cargo
        title_18: "Жидкие грузы",
        intro_18: {
        main_text_18: "Специализированная и безопасная логистика для жидких грузов",
        text_1: "MMSH Logistics предоставляет безопасные и эффективные транспортные решения для жидких грузов, включая нефтепродукты, химические вещества, пищевые жидкости и промышленные жидкости. Перевозка жидких грузов требует специализированных цистерн, температурно-контролируемого хранения и строгого соблюдения нормативных требований. Наш флот включает сертифицированные ISO-контейнеры, флекситанки и наливные цистерны, разработанные для максимальной безопасности и эффективности. Благодаря системам мониторинга в реальном времени, автоматизированной системе предотвращения утечек и передовой маршрутизации мы обеспечиваем безопасную и экономически выгодную доставку. Будь то перевозка опасных химикатов, пищевых масел или фармацевтических жидкостей, наши логистические эксперты предлагают индивидуальные решения, соответствующие отраслевым стандартам и экологическим нормативам."
        },

        projects_18: {
        title: "Развитие логистики жидких грузов",
        items: [
            { title: "Расширение флота транспортных средств для пищевых жидкостей." },
            { title: "Интеграция IoT-систем для предотвращения утечек." },
            { title: "Оптимизация мультимодальных перевозок для химических жидкостей." },
            { title: "Разработка экологически безопасных решений для хранения жидких грузов." }
        ]
        },

        completed_projects_18: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Созданы надежные и быстрые маршруты транспортировки нефтепродуктов." },
            { title: "Успешно внедрен мониторинг жидких грузов в реальном времени." }
        ]
        },
        // Liquid Cargo

        // Passenger Cars
        title_19: "Легковые автомобили",
        intro_19: {
        main_text_19: "Эффективная и безопасная логистика для перевозки легковых автомобилей",
        text_1: "MMSH Logistics специализируется на безопасной и эффективной транспортировке пассажирских автомобилей, включая автомобили класса люкс, электромобили (EV) и коммерческие автопарки. Наша комплексная логистическая сеть обеспечивает беспрепятственную перевозку автомобилей по дорогам, железным дорогам, морем и воздухом, обслуживая производителей, дилеров и частных клиентов. Мы предоставляем закрытый транспорт для дорогостоящих и коллекционных автомобилей, защищая их от воздействия окружающей среды. Наши мультимодальные решения оптимизируют затраты при соблюдении высочайших стандартов безопасности. GPS-мониторинг в реальном времени, индивидуальные страховые решения и специализированное обращение с транспортными средствами обеспечивают безопасную и удобную доставку. Будь то транспортировка одного автомобиля или целого автопарка, MMSH Logistics гарантирует своевременную и надежную доставку без повреждений."
        },
        projects_19: {
            title: "Развитие логистики пассажирских автомобилей",
            items: [
            { title: "Расширение автопарка закрытых перевозчиков для автомобилей класса люкс." },
            { title: "Интеграция ИИ-оптимизации маршрутов для перевозки автомобилей." },
            { title: "Оптимизация мультимодальных перевозок для электромобилей." },
            { title: "Разработка экологически чистых решений для транспортировки автомобилей." }
            ]
        },
        
        completed_projects_19: {
            title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
            items: [
            { title: "Успешно созданы глобальные маршруты транспортировки автомобилей." },
            { title: "Интегрирована GPS-система отслеживания для мониторинга перевозки автомобилей в реальном времени." }
            ]
        },
        // Passenger Cars
        // Reefer Cargo
        title_20: "Рефрижераторные грузы",
        intro_20: {
        main_text_20: "Надежная и контролируемая по температуре логистика для рефрижераторных грузов",
        text_1: "MMSH Logistics специализируется на транспортировке грузов, чувствительных к температуре, включая свежие продукты, молочную продукцию, фармацевтику, морепродукты и замороженные продукты. Наши решения в области рефрижераторной логистики обеспечивают точный температурный контроль на всех этапах цепочки поставок, поддерживая целостность продукции от пункта отправления до пункта назначения. Мы используем современные рефрижераторные контейнеры, склады с холодным хранением и климат-контролируемые грузовики для предотвращения порчи и обеспечения соответствия стандартам безопасности пищевых продуктов и фармацевтической продукции. С помощью ИИ-мониторинга температуры, отслеживания в реальном времени и оптимизированных мультимодальных перевозок мы гарантируем эффективность, надежность и экономичность. Независимо от того, идет ли речь о доставке скоропортящихся продуктов или медицинских товаров, наши индивидуальные логистические решения соответствуют самым высоким стандартам качества."
        },

        projects_20: {
        title: "Развитие логистики рефрижераторных грузов",
        items: [
            { title: "Расширение флота рефрижераторных грузовиков для скоропортящихся продуктов." },
            { title: "ИИ-мониторинг температуры для фармацевтической логистики." },
            { title: "Оптимизированные мультимодальные решения для замороженных и свежих продуктов." },
            { title: "Разработка энергоэффективных холодильных складов." }
        ]
        },

        completed_projects_20: {
        title: "ЗАВЕРШЕННЫЕ ПРОЕКТЫ",
        items: [
            { title: "Создана глобальная цепочка поставок с холодным хранением для пищевых и медицинских грузов." },
            { title: "Интегрирована интеллектуальная система отслеживания рефрижераторных контейнеров с мониторингом температуры в реальном времени." }
        ]
        },
        // Reefer Cargo

        // Drivers' Office
        title_21: "Офис водителей",
        intro_21: {
        main_text_21: "Вознаграждающая и поддерживающая рабочая среда для профессиональных водителей",
        text_1: "В MMSH Logistics мы признаем, что наши водители – это основа наших операций. Мы стремимся обеспечить профессиональную, комфортную и мотивирующую рабочую среду. Наш современный автопарк, тщательно продуманные маршруты и передовые технологии логистики обеспечивают эффективность и удобство в каждой поездке. Мы предлагаем конкурентоспособные зарплаты, возможности карьерного роста и сильную систему поддержки, гарантируя, что наши водители чувствуют себя ценными. Независимо от того, являетесь ли вы опытным водителем или хотите присоединиться к логистической отрасли, MMSH Logistics предлагает стабильность, уважение и ориентированную на водителя корпоративную культуру."
        },

        texts_21: {
        main: "Ключевые преимущества MMSH Logistics",
        mini_1: "Комфортное использование наших услуг",
        mini_2: "Быстрая связь с диспетчерами",
        mini_3: "Доступ к 200+ новым грузовым заказам ежедневно",
        mini_4: "Автоматизированная система диспетчеризации для экономии времени",
        mini_5: "Сокращение задержек при загрузке/разгрузке благодаря уведомлениям в реальном времени",
        mini_6: "Точное отслеживание для предотвращения споров",
        mini_7: "Умное финансовое планирование с персонализированным графиком выплат",
        mini_8: "ИИ-оптимизация маршрутов для минимизации затрат"
        },
        // Drivers' Office

        // Payments
        title_22: "Платежи",
        intro_22: {
        main_text_22: "Бесшовные и прозрачные платежные сервисы для наших водителей",
        text_1: "В MMSH Logistics мы уделяем приоритетное внимание финансовой стабильности и удобству для наших водителей. Наши передовые бухгалтерские и платежные системы обеспечивают своевременную, точную и прозрачную обработку заработной платы, устраняя стресс, связанный с финансовой неопределенностью. Благодаря автоматизированной системе расчета заработной платы, четкой документации и специализированным командам поддержки водители могут сосредоточиться на своей работе, не беспокоясь о сложностях административных процессов. Наши оптимизированные процессы гарантируют своевременные выплаты, легкий доступ к финансовым записям и беспроблемные транзакции. В MMSH Logistics мы ценим наших водителей не только как сотрудников, но и как ключевых партнеров нашего успеха. Наша приверженность эффективности, справедливости и финансовой безопасности делает нас лучшим выбором для профессионалов в сфере логистики. Если у вас есть вопросы, пожалуйста, позвоните по указанным номерам."
        },
        // Payments

        // Movement Restriction
        title_23: "Ограничения на передвижение",
        intro_23: {
        main_text_23: "Понимание ограничений передвижения для водителей в Еврозоне",
        text_1: "Работа и передвижение в Еврозоне для граждан, не являющихся резидентами ЕС, сопряжены с жесткими ограничениями и юридическими требованиями. Для законной деятельности водители должны соблюдать визовые правила, законы о дорожных перевозках и контроль на границах. Виза для работы в Европе (шенгенская рабочая виза) является обязательной для граждан стран, не входящих в ЕС, которые хотят работать в европейских странах. В некоторых случаях могут потребоваться дополнительные разрешения на работу в зависимости от национальных политик. Кроме того, экологические нормы, системы дорожных сборов и ограничения ЕС на рабочие часы водителей могут влиять на передвижение через границы. В MMSH Logistics мы поддерживаем наших водителей, предоставляя консультации по оформлению виз, разрешений на работу и соблюдению транспортных законов, обеспечивая бесперебойную работу и предотвращая штрафы. Если у вас есть вопросы относительно ограничений передвижения и разрешений на работу, пожалуйста, свяжитесь с нами по указанным номерам."
        },
        // Movement Restriction

        // Fuel Cards
        title_24: "Топливные карты",
        intro_24: {
        main_text_24: "Политика использования топливных карт для водителей MMSH Logistics",
        text_1: "В MMSH Logistics мы понимаем, что во время дальних поездок могут возникнуть неожиданные ситуации. Хотя мы рекомендуем водителям самостоятельно управлять своими топливными расходами, в экстренных случаях мы предоставляем топливные карты. Эти случаи включают ситуации, когда водитель временно не может покрыть расходы на топливо из-за непредвиденных обстоятельств. Топливные карты выдаются только в крайнем случае и требуют предварительного одобрения. Наш приоритет – поддержка водителей в критических моментах при сохранении ответственного финансового управления. Если вам нужна помощь с топливными расходами, пожалуйста, свяжитесь с соответствующим отделом для получения консультации."
        },
        // Fuel Cards

        // Business Ethics
        title_25: "Деловая этика MMSH",
        intro_25: {
        main_text_25: "Наша приверженность этичному и ответственному ведению бизнеса",
        text_1: "В MMSH Logistics основными принципами нашей деловой этики являются честность, ответственность и уважение. Мы уделяем приоритетное внимание прозрачности в нашей деятельности, обеспечивая справедливость во всех сделках и партнерствах. Наша приверженность устойчивому развитию побуждает нас внедрять экологически чистые практики и эффективные логистические решения, которые уменьшают наше воздействие на окружающую среду. Мы ценим доверие наших клиентов и сотрудников, создавая рабочую среду, основанную на взаимном уважении, разнообразии и инклюзивности. Соблюдая высочайшие этические стандарты, мы гарантируем, что MMSH Logistics останется надежным лидером отрасли, ориентированным на надежность, инновации и долгосрочный успех."
        },
        // Business Ethics
        // Карьера
        title_26: "Карьера в MMSH",
        intro_26: {
        main_text_26: "Построение успешной карьеры в MMSH Logistics",
        text_1: "В MMSH Logistics мы убеждены, что успешная карьера строится на росте, инновациях и поддерживающей среде. Мы стремимся предоставлять нашим сотрудникам возможности для развития навыков, профессионального роста и значимого вклада в логистическую отрасль. Создавая рабочую среду, в которой ценятся командная работа, креативность и непрерывное обучение, мы обеспечиваем каждого члена команды необходимыми ресурсами и поддержкой для процветания. Благодаря конкурентоспособным преимуществам, прочной этической основе и видению будущего, MMSH Logistics – это идеальное место для развития вашей карьеры и формирования будущего глобальной логистики. Чтобы узнать больше, ищите наши вакансии или стажировки ниже.",
        join_our_team: "Присоединяйтесь к нашей команде",
        view_vacancies: "Просмотреть вакансии",
        apply_for_internship: "Подать заявку на стажировку"
        },   
        // Карьера

        // Вакансии
        title_27: "Вакансии в MMSH",
        intro_27: {
        main_text_27: "Изучите захватывающие вакансии в MMSH Logistics",
        text_1: "В MMSH Logistics мы предлагаем динамичные карьерные возможности для профессионалов, стремящихся к росту, инновациям и поддержке. Мы помогаем нашим сотрудникам развивать навыки, продвигаться по карьерной лестнице и вносить значимый вклад в логистическую отрасль. Наша рабочая среда способствует командной работе, креативности и постоянному обучению, гарантируя, что каждый член команды получает необходимые ресурсы и поддержку для достижения успеха.",
        vacancies: "Просмотреть вакансии"
        }, 
        // Вакансии

        // Стажировка
        title_28: "Стажировка в MMSH",
        intro_28: {
        main_text_28: "Изучите захватывающие вакансии в MMSH Logistics",
        text_1: "В MMSH Logistics мы предлагаем динамичные карьерные возможности для профессионалов, стремящихся к росту, инновациям и поддержке. Мы помогаем нашим сотрудникам развивать навыки, продвигаться по карьерной лестнице и вносить значимый вклад в логистическую отрасль. Наша рабочая среда способствует командной работе, креативности и постоянному обучению, гарантируя, что каждый член команды получает необходимые ресурсы и поддержку для достижения успеха."
        },
        internship_benefits: {
        main_title: "Почему стоит пройти стажировку в MMSH Logistics?",
        description: "Стажировка в MMSH Logistics – это не просто учебный опыт, а возможность запустить свою карьеру в динамичном мире международной логистики. Будь вы студентом, недавним выпускником или человеком, желающим получить отраслевой опыт, наша программа стажировки предлагает практическое обучение, профессиональное наставничество и реальный опыт работы в логистике.",
        benefits: {
            experience: {
            title: "Практический отраслевой опыт",
            description: "Получите непосредственный опыт работы в процессах логистики, включая управление цепочками поставок, экспедирование грузов, таможенное оформление и международные торговые регламенты."
            },
            mentorship: {
            title: "Наставничество от отраслевых экспертов",
            description: "Работайте бок о бок с опытными профессионалами, которые помогут вам развить ключевые технические и бизнес-навыки."
            },
            career_growth: {
            title: "Возможности карьерного роста",
            description: "Многие из наших стажеров переходят на постоянную работу, превращая стажировку в ступеньку к долгосрочной карьере в логистике."
            },
            networking: {
            title: "Нетворкинг и профессиональное развитие",
            description: "Заводите полезные связи с лидерами отрасли, посещайте деловые встречи и стройте отношения, которые помогут в вашей будущей карьере."
            },
            innovation: {
            title: "Инновационная учебная среда",
            description: "Мы делаем упор на технологические решения в логистике, давая вам возможность работать с инструментами на основе ИИ, автоматизированными системами и аналитикой данных."
            },
            personal_growth: {
            title: "Личностный рост и развитие навыков",
            description: "Развивайте навыки решения проблем, коммуникации и критического мышления в динамичной международной рабочей среде."
            }
        },
        conclusion: "В MMSH Logistics мы предлагаем не просто стажировки – мы создаем карьерные возможности, которые подготовят вас к работе в глобальной логистической отрасли. Начните свой путь с нами уже сегодня!"
        },
        // Стажировка

        // Локации
        locations: {
        city: "Город",
        phone_number: "Номер телефона",
        data: [
            { country: "cn", city: "Алашанькоу, Китай", phone: "+86 901 123 45 67" },
            { country: "us", city: "Огайо, США", phone: "+1 614 555 78 90" },
            { country: "de", city: "Франкфурт, Германия", phone: "+49 69 123 45 67" },
            { country: "uz", city: "Андижан, Узбекистан", phone: "+998 74 456 78 90" },
            { country: "tr", city: "Стамбул, Турция", phone: "+90 212 987 65 43" }
        ],
        data2: [
            { country: "jp", city: "Киото, Япония", phone: "+81 75 234 56 78" },
            { country: "it", city: "Милан, Италия", phone: "+39 02 123 45 67" },
            { country: "it", city: "Рим, Италия", phone: "+39 06 789 01 23" },
            { country: "ru", city: "Москва, Россия", phone: "+33 1 234 56 78" }, 
            { country: "cn", city: "Шэньчжэнь, Китай", phone: "+86 901 234 56 78" }
        ]
        },
        // Локации

        // Консалтинг
        consulting_title: "Консалтинг",
        consulting_heading: "Надежный логистический партнер",
        consulting_description: "В современном динамичном мире бизнесу требуются надежные, эффективные и инновационные логистические решения, чтобы опережать конкурентов. В MMSH Logistics мы понимаем, что каждый груз несет в себе нечто большее, чем просто товары — это репутация вашего бизнеса, доверие клиентов и потенциал роста. Именно поэтому мы предоставляем бесшовные, экономически эффективные и технологически продвинутые логистические услуги, разработанные для того, чтобы компании могли легко расширяться за границу. Обладая сильным присутствием в международных перевозках, MMSH Logistics обеспечивает бизнесу доступ к бесперебойным, своевременным и простым решениям по доставке. Независимо от того, занимаетесь ли вы импортно-экспортными операциями, управлением цепями поставок или экспедированием грузов, наша компания предлагает индивидуальные логистические стратегии для оптимизации эффективности вашего бизнеса и снижения затрат.",
        contact_email: "info@mmshlogistics.com",
        contact_phone: "+998 90 123 45 67",
        // Консалтинг
        // Таможенные услуги
        customs_services_title: "Таможенные услуги",
        customs_services_heading: "Эффективные и надежные таможенные решения",
        customs_services_description: "В MMSH Logistics мы понимаем, что соблюдение таможенных правил – один из важнейших аспектов международной торговли. Наши таможенные услуги обеспечивают бесперебойный и удобный процесс оформления, позволяя вашим грузам беспрепятственно пересекать границы. Благодаря нашему опыту компании получают преимущества в виде сокращения задержек, минимизации затрат и полного соответствия глобальным торговым нормам. Будь то импорт или экспорт, MMSH Logistics предлагает индивидуальные решения по таможенной документации, классификации тарифов, оптимизации пошлин и соблюдению нормативных требований. Наша команда экспертов тесно сотрудничает с таможенными органами, чтобы гарантировать эффективное оформление грузов, экономя время и предотвращая ненужные осложнения.",
        // Таможенные услуги

        // Проектная логистика
        project_logistics_title: "Проектная логистика",
        project_logistics_heading: "Комплексные решения в области проектной логистики",
        project_logistics_description: "MMSH Logistics специализируется на предоставлении индивидуальных логистических решений для крупных промышленных и инфраструктурных проектов. Наш опыт в области проектной логистики гарантирует беспрепятственную транспортировку негабаритных, тяжелых и срочных грузов через международные границы. Мы управляем всей цепочкой поставок — от планирования маршрутов и управления грузоперевозками до таможенного оформления и доставки на объект. Благодаря сильной глобальной сети и передовым логистическим технологиям MMSH Logistics помогает компаниям эффективно, безопасно и в соответствии с требованиями реализовывать сложные проекты. Независимо от того, идет ли речь о транспортировке оборудования для энергетики, строительства или промышленных предприятий, мы гарантируем своевременную доставку в рамках бюджета.",
        // Проектная логистика

        // Склады
        warehouse_services_title: "Складские услуги",
        warehouse_services_heading: "Надежные и эффективные складские решения",
        warehouse_services_description: "MMSH Logistics предлагает первоклассные складские услуги, разработанные для оптимизации вашей цепочки поставок. Наши современные складские комплексы обеспечивают надежное, температурно-контролируемое и высокоэффективное хранение грузов, соответствующее индивидуальным потребностям бизнеса. Независимо от того, требуется ли вам краткосрочное хранение, долгосрочное управление запасами или кросс-докинг, наши объекты оснащены новейшими технологиями, обеспечивающими отслеживание в реальном времени и бесперебойную работу. MMSH Logistics специализируется на оптимизации складских операций, снижении затрат и улучшении сроков доставки. Наша команда профессионалов гарантирует, что ваши товары обрабатываются с максимальной точностью и заботой, обеспечивая бесперебойную работу вашего бизнеса.",
        // Склады
        // Страхование грузов
        insurance_services_title: "Услуги страхования грузов",
        insurance_services_heading: "Комплексное страхование грузов для максимальной безопасности",
        insurance_services_description: "Как неотъемлемая часть логистических услуг, MMSH Logistics предлагает своим клиентам надежные решения по страхованию грузов. Наше страхование 'Все риски' предоставляет наиболее удобное и безопасное покрытие, обеспечивая полную защиту вашего груза во время транспортировки. В случае непредвиденных обстоятельств эта политика гарантирует полное возмещение убытков.",

        insurance_services_providers: "MMSH Logistics сотрудничает с ведущей страховой компанией 'Inson', чтобы предоставить высококачественные услуги по страхованию грузов. Благодаря 'Inson' мы гарантируем нашим клиентам премиальное страховое покрытие, с возможностью страхования грузов на сумму до €1 500 000 за одну перевозку. Наши страховые решения обеспечивают полную безопасность и соответствие международным стандартам логистики.",

        insurance_services_benefits_heading: "Ключевые преимущества страхования грузов с MMSH Logistics",
        insurance_services_benefits: "Конкурентные тарифы: Благодаря высокому объему застрахованных грузов мы предлагаем нашим клиентам выгодные страховые тарифы, оптимизирующие общие затраты на транспортировку. Гибкие варианты оплаты: Оплата страхования может производиться на любом этапе транспортировки, одновременно с оплатой перевозки. В стандартный пакет услуг входит отправка страхового полиса по электронной почте или факсу. Оригинал документа может быть выслан по запросу. Система управления претензиями: Наши специалисты помогают организовать экспертизу поврежденного груза и обработку страховых претензий. В случае инцидента клиенты должны следовать инструкциям экспертов MMSH Logistics. Минимизация рисков: Чтобы избежать финансовых потерь, MMSH Logistics сотрудничает со страховой компанией 'Inson', обеспечивая страховое покрытие грузов до €1 500 000 за одну перевозку.",

        insurance_services_coverage_heading: "Варианты страхового покрытия",
        insurance_services_coverage: "MMSH Logistics предоставляет страхование грузов на следующих условиях: Страхование 'Все риски': Полное возмещение стоимости груза в случае полной утери и покрытие затрат на восстановление при повреждениях. Ограниченное страхование: Компенсация за утрату или повреждение, вызванные квалифицированными инцидентами.",

        insurance_services_additional_coverage: "Наши страховые полисы покрывают груз во время погрузки на объекте отправителя и выгрузки в пункте назначения, во время хранения на транзитных складах, а также при перегрузке между различными видами транспорта.",

        insurance_services_who_can_insure: "Страхователем может выступать любая сторона, заинтересованная в сохранности груза, например, его владелец. По запросу MMSH Logistics может оформить страхование без указания конкретного выгодоприобретателя, что позволяет выплатить компенсацию ответственному лицу в момент возникновения убытка.",

        insurance_services_rates_heading: "Тарифы на страхование грузов",
        insurance_services_rates: "Базовые страховые тарифы варьируются от 0,25% до 0,35% от стоимости счета. Итоговая ставка зависит от различных факторов, включая стоимость груза, его тип, упаковку, объем перевозки, маршрут и другие параметры. MMSH Logistics предлагает специальные тарифы для долгосрочных партнеров. Обычно франшиза (непокрытый убыток) устанавливается на уровне нуля, обеспечивая полное возмещение даже минимальных потерь.",

        insurance_services_options_heading: "Доступные варианты страхования",
        insurance_services_options: "Покрытие на 110% от стоимости груза по счету, Покрытие на стоимость груза + транспортные расходы, Покрытие на 110% от стоимости груза по счету + транспортные расходы.",

        insurance_services_damage_handling_heading: "Обработка страховых случаев",
        insurance_services_damage_handling: "Наша опытная страховая команда занимается экспертизой поврежденного груза, сбором необходимых документов по претензии и переговорами со страховщиками. Благодаря нашему партнерству со страховой компанией 'Inson', MMSH Logistics гарантирует, что клиенты могут не беспокоиться о безопасности груза и получают полное возмещение за любые потери, с покрытием до €1 500 000 за перевозку.",
        // Страхование грузов

        // Типы транспортных средств
        vehicle_types: {
        title: "ТИПЫ ТРАНСПОРТНЫХ СРЕДСТВ",
        description: "Для морских перевозок MMSH Logistics использует специально адаптированные контейнеры, включая:",
        items: [
            "ISO-контейнеры различных размеров",
            "Специальные контейнеры для негабаритных, навалочных и сыпучих грузов",
            "Танк-контейнеры для перевозки жидких грузов",
            "Рефрижераторные контейнеры для скоропортящихся товаров",
            "Контейнеры для перевозки автомобилей, небольших грузов и опасных веществ"
        ]
        },

        // Наши возможности
        capabilities: {
        title: "НАШИ ВОЗМОЖНОСТИ",
        description: "MMSH Logistics предлагает ряд специализированных услуг железнодорожных перевозок, обеспечивающих безопасную и эффективную доставку.",
        items: [
            "Температурно-контролируемые перевозки с использованием термовагоны, изотермических и рефрижераторных вагонов.",
            "Транспортировка автомобилей, машин и оборудования.",
            "Эффективная транспортировка скоропортящихся грузов по железной дороге.",
            "Обработка крупных, но легких объемов грузов более 120 м³.",
            "Использование ускоренных поездов для перевозок на дальние расстояния."
        ],
        final_note: "MMSH стремится предоставлять гибкие, надежные и индивидуальные логистические решения."
        },

        // Регламенты и документация
        regulations: {
        title: "РЕГЛАМЕНТЫ/ДОКУМЕНТАЦИЯ",
        description: "Морские грузоперевозки регулируются рядом национальных и международных правовых норм.",
        list: [
            { title: "Ключевые конвенции", content: "В Узбекистане морские перевозки регулируются Конвенцией ООН." },
            { title: "Национальное законодательство", content: "Помимо международных соглашений, MMSH соблюдает национальные законы Узбекистана." },
            { title: "Специализированный контроль", content: "MMSH Logistics внимательно следит за изменениями в морском законодательстве." },
            { title: "Документация", content: "Наша команда предоставляет комплексную поддержку по оформлению всей необходимой транспортной документации." }
        ],
        conclusion: "Сосредоточившись на соблюдении законодательства и операционной эффективности, MMSH Logistics гарантирует, что каждая перевозка осуществляется безопасно."
        },

        // Главные категории
        start: {
        trucks: "Грузовики",
        train: "Поезда",
        boats: "Суда",
        air: "Воздушный транспорт",
        multimodal: "Мультимодальные",
        collective: "Сборные грузы"
        },

        big: {
        trucks: "Наша компания обеспечивает быструю и надежную доставку благодаря современному автопарку.",
        train: "Мы используем преимущества железнодорожного транспорта для эффективной доставки грузов.",
        boats: "MMSH Logistics использует морской транспорт для надежной перевозки грузов.",
        air: "Мы предоставляем быструю и эффективную доставку авиаперевозками.",
        multimodal: "Наши мультимодальные решения обеспечивают бесшовную логистику.",
        collective: "Наша компания предлагает удобные сборные перевозки."
        },

        // Логотип и описание компании
        logo_text: "MMSH Logistics",
        about_mmsh: "MMSH Logistics стремится к обеспечению надежных, эффективных и качественных логистических решений для своих корпоративных клиентов. Мы гордимся высоким уровнем сервиса, оптимизацией цепочек поставок и передовыми технологиями. Ваш успех – наш приоритет.",
        career: "Карьера в MMSH",
        work: "Откройте для себя мир безграничных возможностей и инноваций в MMSH Logistics.",

        Responsible: "Ответственность",
        Supportive: "Поддержка",
        Comfortable: "Комфорт",

        responsible: "В MMSH мы берем на себя полную ответственность за предоставление безупречных логистических решений. Наша команда гарантирует своевременную и безопасную транспортировку, тщательно прорабатывая каждую деталь.",
        supportive: "Мы верим в сильные партнерские отношения и постоянную поддержку. Будь то международная перевозка или локальная доставка, наши специалисты всегда готовы помочь и направить вас на каждом этапе.",
        comfortable: "Благодаря удобным услугам и эффективной организации работы, мы делаем логистику простой и понятной. Наши клиенты могут рассчитывать на прозрачные процессы и бесперебойные перевозки.",

        SignUp: "Зарегистрируйтесь сегодня",
        Learn_more: "Узнать больше",
        Search_more: "Искать больше",
        Back_to_top: "Вернуться наверх",
        View_details: "Посмотреть детали",
        loading: "Загрузка...",

        regions: {
        china_team_leader: "Руководитель команды в Китае",
        central_asia_russia_team_leader: "Руководитель команды по Центральной Азии и России",
        europe_team_leader: "Руководитель команды в Европе"
        },
        names: {
            abdulloh: "Абдуллох",
            nuriddin: "Нуриддин",
            ulugbek: "Улугбек"
          },
          
          texts: {
            trustworthy_company: "Надежная компания с многочисленными сертификатами.",
            shipping_with_trains: "Мы также предлагаем перевозку грузов по железной дороге.",
            experienced_drivers: "Опытные водители всегда готовы помочь вам в любой момент."
          },
          
          write: {
            km: "92.41",
            done: "12731",
            routes: "975",
            loaders: "3211",
            drivers: "7445"
          },
          
          write_2: {
            km_text: "Миллионы километров",
            done_text: "Завершенные заказы",
            routes_text: "Целевые торговые маршруты",
            loaders_text: "Корпоративные клиенты",
            drivers_text: "Надежные подрядчики"
          },
          
          write_3: {
            more: "Подробнее",
            see_statistics: "Посмотреть статистику",
            learn_more: "Узнать больше",
            see: "Посмотреть",
            check: "Проверить"
          },
          
          Special: {
            Industry_Solutions: "Решения для отрасли",
            Special_Loads: "Специальные грузы",
            Learn_more: "Узнать больше",
          },
          
          Career: {
            make_career: "Карьера в MMSH",
            text: "Профессионалы в MMSH могут развиваться в сферах маркетинговой стратегии, управления продажами, клиентских отношений, планирования мероприятий и управления гостеприимством. Работа требует сильных навыков коммуникации, лидерства и организации, ориентируясь на построение отношений с клиентами и развитие бизнеса.",
            learn_more: "Узнать больше"
          },
          
          News: {
            News_in_Company: "Новости компании",
            Growth_in_MMSH: "Рост MMSH",
            MMSH_is: "MMSH открыт для амбициозных людей",
            News_of_MMSH: "Новости MMSH",
            learn_more: "Узнать больше",
            show_less: "Показать меньше",
            text_1: "Компания MMSH с радостью объявляет о пополнении своего автопарка новыми современными грузовиками. Эти транспортные средства оснащены передовыми технологиями, обеспечивающими повышенную эффективность, безопасность и экологичность.",
            text_2: "MMSH гордится своими сотрудниками, чья преданность делу и профессионализм являются движущей силой успеха компании. Ориентируясь на непрерывное профессиональное развитие, MMSH предоставляет своей команде возможности для обучения, стимулируя инновации и совершенство.",
            full_text_1: "MMSH Logistics продолжает расти и расширять свою деятельность по всему миру. Новые грузовики повысят нашу способность обслуживать клиентов быстрее и надежнее. Мы стремимся поддерживать высокие стандарты безопасности, устойчивости и эффективности во всех наших операциях.",
            full_text_2: "В рамках наших усилий по развитию культуры совершенства MMSH с гордостью предлагает различные программы профессионального развития для своих сотрудников. От лидерских тренингов до технического обучения – мы поддерживаем рост нашей команды, чтобы они могли внести свой вклад в наше общее видение успеха."
          },
          
          sections: {
            mmsh: "MMSH",
            transport: "Транспорт",
            industry_solutions: "Для отрасли",
            special_loads: "Специальные",
            for_drivers: "Для водителей",
            contacts: "Контакты",
            career: "Карьера"
          },
          
          links: {
            about_company: "О компании",
            history_mission: "История и миссия",
            certificates: "Сертификаты",
            trucks: "Грузовики",
            trains: "Поезда",
            ships: "Суда",
            air: "Авиа",
            multimodal: "Мультимодальные перевозки",
            chemicals: "Химическая продукция",
            technology: "Технологии",
            groceries: "Продукты питания",
            agriculture: "Сельскохозяйственная продукция",
            construction: "Строительство",
            pharmaceuticals: "Фармацевтические товары",
            fashion: "Модная индустрия",
            expensive: "Дорогие грузы",
            passenger_cars: "Пассажирские автомобили",
            liquid_cargo: "Жидкие грузы",
            bulk_cargo: "Наливные грузы",
            heavy_cargo: "Тяжелые грузы",
            reefer_cargo: "Рефрижераторные грузы",
            carriers_office: "Офис перевозчиков",
            payments: "Платежи",
            movement_restrictions: "Ограничения передвижения",
            fuel_cards: "Топливные карты",
            mmsh_offices: "Офисы MMSH",
            contact_experts: "Связаться с экспертами",
            business_ethics: "Деловая этика",
            career: "Карьера",
            vacancies: "Вакансии",
            internship: "Стажировка"
          },
          
          business_description: "MMSH Logistics стремится соответствовать разнообразным потребностям, ожиданиям и бизнес-целям наших клиентов и партнеров. Используя передовые технологии, отраслевой опыт и клиент-ориентированный подход, мы обеспечиваем бесперебойную и эффективную логистическую деятельность на международном уровне. Наши индивидуальные решения помогают решать сложные задачи цепочки поставок, оптимизировать транспортные сети и повышать операционную эффективность.",
          
          certifications: "СЕРТИФИКАТЫ",
          certificate_description: "Эти сертификаты подтверждают соответствие глобальным стандартам.",
          associations: "АССОЦИАЦИИ",
          associations_description: "MMSH сотрудничает с ведущими организациями в области логистики, торговли и транспорта для обеспечения соответствия и эффективности на международных рынках.",
          no_certificates: "Сертификатов нет.",
          no_associations: "Ассоциаций нет.",

          // Список сертификатов
        certificates_list: [
            {
            title: "Официальный сертификат MMSH",
            description: "Этот сертификат гарантирует высокие стандарты качества, безопасности и устойчивости. Он подтверждает, что наши системы управления соответствуют международным стандартам качества и экологии.",
            document: "official"
            },
            {
            title: "GDP - Надлежащая дистрибьюторская практика",
            description: "Обеспечивает надлежащую дистрибуцию и обработку фармацевтических продуктов. Этот сертификат подтверждает соответствие стандартам безопасности и гигиены во время транспортировки.",
            document: "proof"
            },
            {
            title: "Комплексное страхование грузов",
            description: "Защищает грузы от потерь, повреждений или краж во время перевозки. Наше страховое покрытие обеспечивает финансовую безопасность и управление рисками в международной логистике.",
            document: "insurance"
            },
            {
            title: "TAPA - Ассоциация защиты транспортируемых активов",
            description: "Сертификат, обеспечивающий безопасность цепочки поставок и управление рисками. Признан за защиту ценных грузов от краж и подделок в пути.",
            document: "license"
            },
            {
            title: "Наш сертификат ATI.SU за лидерство в Узбекистане",
            description: "Сертификат, обеспечивающий безопасность цепочки поставок и управление рисками. Признан за защиту ценных грузов от краж и подделок в пути.",
            document: "license"
            },
            {
            title: "Наш сертификат ATI.SU за вхождение в топ-10 компаний Узбекистана",
            description: "Сертификат, обеспечивающий безопасность цепочки поставок и управление рисками. Признан за защиту ценных грузов от краж и подделок в пути.",
            document: "license"
            },          
        ],        
        
        // Список ассоциаций (теперь 11 элементов)
        associations_list: [
            "FPAL - С момента основания FPAL Великобританией для нефтегазовой отрасли он помогает операторам успешно выполнять контракты и повышать бизнес-эффективность.",
            "EIC - Совет энергетических отраслей Великобритании, поддерживающий глобальные цепочки поставок в логистике и соответствии нормативам.",
            "NCBFAA - Национальная ассоциация брокеров и экспедиторов США, обеспечивающая соблюдение международных правил экспедирования грузов.",
            "FIATA - Международная федерация экспедиторских ассоциаций, объединяющая логистических провайдеров по всему миру.",
            "AIFFU - Ассоциация международных экспедиторов Украины, укрепляющая транспортные связи в Восточной Европе.",
            "ZMPD - Ассоциация международных автоперевозчиков Польши, оптимизирующая логистические маршруты между Европой и Китаем.",
            "TAPA - Ассоциация защиты транспортируемых активов, разрабатывающая протоколы безопасности для защиты цепочек поставок.",
            "BVL - Федеральная логистическая ассоциация Германии, продвигающая устойчивые логистические решения в ЕС.",
            "TIACA - Международная ассоциация воздушных грузоперевозок, объединяющая участников авиагрузоперевозок по всему миру.",
            "BRITA - Международный транспортный альянс «Один пояс — один путь», упрощающий транспортные связи между Китаем и Европой.",
            "LANDBRIDGE - Логистический альянс Landbridge, поддерживающий трансеазиатские перевозки и таможенное оформление для партнеров из Китая и Европы."
        ],
        
        // Дополнительные описания ассоциаций
        associations_paragraphs: [
            "MMSH активно сотрудничает с ведущими логистическими организациями для обеспечения эффективности глобальной торговли. Наши партнерства в Китае и Европе позволяют нам оптимизировать таможенное оформление, складирование и доставку.",
            "Благодаря членству в ключевых логистических альянсах, MMSH гарантирует бесперебойные цепочки поставок, соответствующие международным торговым нормативам и стандартам безопасности.",
            "Сильное присутствие в инициативе «Один пояс — один путь» позволяет MMSH оптимизировать маршруты логистики для европейских партнеров, ускоряя и удешевляя перевозки.",
            "Сотрудничество с европейскими логистическими федерациями позволяет нам соблюдать законы ЕС в сфере транспорта, улучшая процессы международных перевозок."
        ],
        
        // Боковое меню
        home: "Главная",
        orders: "Заказы",
        messages: "Сообщения",
        profile: "Профиль",
        contacts: "Контакты",
        home_desc: "Перейти на главную страницу",
        orders_desc: "Просмотр заказов на перевозку",
        messages_desc: "Проверить сообщения",
        profile_desc: "Просмотреть профиль",
        contacts_desc: "Найти контактные данные",
        
        // Вход в систему
        login_title: "Вход для сотрудников",
        username: "Имя пользователя",
        password: "Пароль",
        login_btn: "Войти",
        footer_text: "© 2025 MMSH Company",
        error_required: "Необходимо ввести имя пользователя и пароль",
        // Вход в систему
        
        // Код подтверждения
        success: "Успех",
        success_message: "Вы успешно зарегистрированы как сотрудник.",
        return_btn: "Вернуться",
        // Код подтверждения
        // Ошибка
        error: "Ошибка",
        error_message: "Извините, вы не являетесь сотрудником.",
        retry_btn: "Повторить попытку",
        // Ошибка

        // Профиль
        welcome: "Добро пожаловать, {{username}}!",
        profile_message: "Мы рады видеть вас в MMSH 😇",
        logout: "Выйти",
        // Профиль

        Details: "Детали", 

        // Эксперты
        experts: {
        john_doe: {
            name: "Равшанбек Ахмаджонов",
            expertise: "Железнодорожная логистика",
            mission: "Эксперт по транспортировке дорогостоящих грузов по Европе."
        },
        jane_smith: {
            name: "Оятилло Хамиджанов",
            expertise: "Грузоперевозки и транспорт",
            mission: "Профессиональный менеджер по грузоперевозкам, обеспечивающий бесперебойную торговлю между США и Китаем."
        },
        michael_lee: {
            name: "Чирмашев Бекзод",
            expertise: "Директор",
            mission: "Специалист по международным торговым отношениям."
        },
        sophia_brown: {
            name: "Ойкиз Муъминова",
            expertise: "Международные перевозки",
            mission: "Лидер по перевозке негабаритных грузов из Китая в Европу."
        },
        liam_garcia: {
            name: "Гули Адхамжонова",
            expertise: "Таможенное оформление и соответствие требованиям",
            mission: "Эксперт по европейским таможенным правилам для ценных грузов."
        },
        olivia_martinez: {
            name: "Зухра Кудратиллаева",
            expertise: "Складская логистика",
            mission: "Стратег по автоматизации складов для крупных распределительных центров в Америке."
        },
        william_harris: {
            name: "Кулдашев Баходиржон",
            expertise: "Холодовая цепь",
            mission: "Профессионал в фармацевтической логистике с контролируемой температурой на немецком рынке."
        },
        emma_wilson: {
            name: "Сардор Хусанбоев",
            expertise: "Последняя миля в США",
            mission: "Ведущий эксперт по быстрой доставке последней мили в США."
        },
        ethan_carter: {
            name: "Абдурахмонов Камронбек",
            expertise: "Логистика в Европе",
            mission: "Опытный специалист по управлению международными грузоперевозками между США и Россией."
        },
        ava_robinson: {
            name: "Аббосбек Мунаваров",
            expertise: "Логистика в России",
            mission: "Профессиональный логистический менеджер, специализирующийся на экспресс-доставках по Европе."
        },
        noah_adams: {
            name: "Исмоилов Асилбек",
            expertise: "Логистика и цепочки поставок",
            mission: "Старший стратег по оптимизации логистических потоков между Китаем и Европой."
        },
        isabella_thompson: {
            name: "Иброхимжон Мавлонов",
            expertise: "Грузоперевозки и транспорт",
            mission: "Специалист по межконтинентальным железнодорожным перевозкам из Китая в Германию."
        },
        lucas_white: {
            name: "Улугбек Олимов",
            expertise: "Управление автопарком",
            mission: "Эксперт по эксплуатации автопарка, специализирующийся на внедрении электрических грузовиков в США."
        },
        mia_johnson: {
            name: "Фаррух Хаитов",
            expertise: "Международные перевозки",
            mission: "Эксперт по сокращению задержек при доставке в крупных портах Европы."
        },
        benjamin_hall: {
            name: "Зайнабидин Камолдинов",
            expertise: "Менеджер",
            mission: "Профессионал в области тарифных переговоров и соблюдения норм торговли между Китаем и Европой."
        },
        ibrohimjon: {
            name: "Иброхимджон Исаков",
            expertise: "Развитие менеджмента",
            mission: "Развитие менеджмента в России, Турции и Европе"
        },
        doniyor: {
            name: "Дониёр Жураев",
            expertise: "Менеджер по грузоперевозкам",
            mission: "Менеджер по торговле с Россией, Беларусью и Центральной Азией"
        },
        Hide_Contact: "Скрыть контакт",
        Contact: "Контакт",
        Contact_with_Experts: "Связаться с экспертами",
        },
        // Эксперты

        // Подвал
        quick_links: "Быстрые ссылки",
        about: "О компании",
        contact: "Контакты",
        news: "Новости",
        certificates: "Сертификаты",
        resources: "Ресурсы",
        blog: "Блог",
        careers: "Карьера",
        support: "Поддержка",
        business_ethics: "Бизнес-этика",
        register_as_staff: "Регистрация для сотрудников",
        staff_only: "Только для зарегистрированных пользователей",
        staff: "Сотрудники",
        all_rights_reserved: "Все права защищены.",
        // Подвал

        // Типы грузов
        cargo_types: {
        title: "Типы грузов",
        description: "MMSH Logistics предоставляет первоклассные услуги по перевозке различных видов грузов, гарантируя безопасную, эффективную и своевременную доставку по всему миру.",
        items: [
            "Навалочные грузы - Эффективная транспортировка больших объемов неупакованных товаров.",
            "Жидкие грузы - Безопасная обработка и транспортировка жидкостей и химикатов.",
            "Рефрижераторные грузы - Перевозка скоропортящихся товаров с контролем температуры.",
            "Контейнерные грузы - Безопасная и стандартизированная перевозка в морских контейнерах.",
            "Опасные грузы - Специализированная логистика для опасных и регулируемых материалов.",
            "Проектные грузы - Индивидуальные решения для негабаритных и сложных перевозок.",
            "Генеральные грузы - Надежная транспортировка стандартных товаров и продукции."
        ]
        },
        // Типы грузов

        // Заголовки городов
        header: {
        Andijon: "Андижан",
        Alashankou: "Алашанькоу",
        Tashkent: "Ташкент",
        },
        // Заголовки городов
        advantages: {
            title: "НАШИ ПРЕИМУЩЕСТВА",
            experience: {
              title: "Опыт",
              description: "MMSH Logistics имеет более 17 лет опыта в железнодорожных перевозках, обслуживая клиентов из различных отраслей, включая химию, деревообработку, металлургию и другие."
            },
            safety: {
              title: "Безопасность",
              description: "Наши специалисты обеспечивают безопасность и сохранность грузов во время транспортировки, используя контейнеры, правильное распределение нагрузки, своевременные замеры и корректную маркировку."
            },
            comprehensiveness: {
              title: "Комплексность",
              description: "Помимо транспортных услуг, MMSH Logistics предоставляет складские услуги, оформление таможенной документации и страхование. Наши внутренние агентства гарантируют высокое качество таможенных услуг."
            },
            insurance: {
              title: "Страхование",
              description: "Каждый груз, перевозимый MMSH, застрахован на сумму до 3 000 000 евро, страховое покрытие предоставляется известной швейцарской страховой компанией HongKong (HongKong Insurance Company Ltd)."
            }
          },
          map: "НАШ ГЕОГРАФИЧЕСКИЙ ОХВАТ",
          // Sidebar Products
            submission_failed: "Отправка не удалась. Попробуйте снова.",
            fill_form_specialist: "Заполните форму, чтобы связаться со специалистом.",
            your_question: "Ваш вопрос",
            your_name: "Ваше имя",
            your_email: "Ваш email",
            next: "Далее",
            submitting: "Отправка...",
            submit: "Отправить",
            thank_you: "Спасибо! Диспетчер свяжется с вами в ближайшее время.",
            logistics_solutions: "Логистические решения",
            trucks: "Грузовики »",
            trains: "Поезда »",
            ships: "Корабли »",
            air: "Авиа »",
            multimodal: "Мультимодальные перевозки »",
            additional_services: "Дополнительные услуги",
            consulting: "Консалтинг »",
            customs_services: "Таможенные услуги »",
            insurance: "Страхование »",
            project_logistics: "Проектная логистика »",
            warehouse_services: "Складские услуги »",
        // Sidebar Products
        // Request for cargo transportation
        request: "Запрос на перевозку",form: {
            aboutCompany: "О вашей компании",
            companyName: "Название компании",
            companyAddress: "Адрес компании",
            contactInfo: "Контактная информация",
            contactName: "Имя контакта",
            contactSurname: "Фамилия контакта",
            contactPhone: "Контактный телефон",
            email: "Электронная почта",
            cargoDetails: "Детали груза",
            fromCountry: "Выберите страну отправления",
            toCountry: "Выберите страну назначения",
            cargoType: "Тип груза",
            description: "Описание",
            privacyPolicy: "Заполняя эту форму, я подтверждаю свое согласие с политикой конфиденциальности.",
            promotions: "Я согласен получать новости, предложения и рекламную информацию от MMSH по электронной почте.",
            send: "Отправить",
            sending: "Отправка...",
            success: "Форма успешно отправлена!",
            error: "Не удалось отправить форму."
          },
          succes: "Вы успешно запросили грузоперевозку. Диспетчер скоро свяжется с вами.",
        // Request for cargo transportation
        // Check cargoes
            loading_cargo: "Загрузка...",
            errorFetchingCargo: "Ошибка при получении запросов на груз.",
            cargoRequests: "Запросы на грузоперевозки",
            cargoType: "Тип груза",
            viewDetails: "Посмотреть детали",
        // Check cargoes
        // Check cargo details
            cargo_details: "Вы уверены, что хотите удалить этот запрос на груз?",
            Cargo_Details: "Детали груза",
            company_name: "Название компании",
            company_address: "Адрес компании",
            contact_name: "Контактное лицо",
            contact_phone_detail: "Контактный телефон",
            email: "Электронная почта",
            cargo_type: "Тип груза",
            description: "Описание",
            agree_privacy_policy: "Согласие с политикой конфиденциальности",
            agree_promotions: "Согласие на рекламные предложения",
            save_changes: "Сохранить изменения",
            cancel: "Отмена",
            yes: "Да",
            no: "Нет",
            delete_cargo: "Удалить груз",
            edit_cargo_details: "Редактировать",          
        // Check cargo details
        // Vacancies
            career_opportunities: "Вакансии в MMSH",
            vacancies: "Вакансии",
            join_our_team: "Присоединяйтесь к нашей команде",
            explore_opportunities: "Откройте для себя захватывающие возможности с нами.",
            search_vacancies: "Поиск вакансий...",
            vacancy: "Вакансия",
            audience: "Целевая аудитория",
            job_category: "Категория работы",
            location: "Местоположение",
            active: "Активно",
            not_active: "Не активно",
            no_vacancies: "Вакансий не найдено",
        // Vacancies
        // ChatBot
            ask: "Спросите о MMSH",
            sorry: "Извините, я не смог это понять.",
        // ChatBot
        // About page
            header_title: "Безопасная, амбициозная и эффективная транспортная компания.",
            header_description: "MMSH Logistics — надежная и эффективная транспортная компания, ориентированная на безопасные и инновационные логистические решения.",
            about_company: "О компании",
            read_more: "Читать далее",
            read_less: "Скрыть",
            
            quality: "Качество",
            quality_short: "MMSH Logistics обеспечивает высокое качество, безопасность и эффективность поставок.",
            quality_full: "В MMSH Logistics контроль качества лежит в основе всего, что мы делаем. Мы внедряем строгие стандарты и постоянный мониторинг, чтобы каждая поставка выполнялась с точностью и заботой. Наша преданная команда гарантирует, что все процессы, от упаковки до доставки, соответствуют самым высоким стандартам качества, обеспечивая безопасную и эффективную транспортировку для наших клиентов.",
            
            caring_nature: "Забота",
            caring_nature_short: "Мы уделяем приоритетное внимание устойчивому развитию и экологически чистым практикам.",
            caring_nature_full: "В MMSH Logistics мы привержены устойчивому развитию. Мы интегрируем экологически чистые практики во всей нашей деятельности, начиная с сокращения выбросов и оптимизации использования ресурсов. Наш фокус на экологически чистой логистике помогает нам способствовать созданию более чистой окружающей среды, обеспечивая при этом эффективные и надежные услуги для наших клиентов.",
            
            assistance: "Помощь",
            assistance_short: "Краткий обзор этой статьи.",
            assistance_full: "В MMSH Logistics мы гордимся тем, что являемся надежным партнером для наших клиентов. Наша команда предана делу обеспечения надежной помощи на каждом этапе, от планирования до доставки. Мы предлагаем решения, адаптированные к уникальным потребностям каждого клиента, обеспечивая бесперебойный и поддерживающий процесс.",
            
            innovations: "Инновации",
            innovations_short: "Наша компания открыта для новых идей.",
            innovations_full: "В MMSH Logistics инновации являются основным элементом нашей деятельности. Мы постоянно исследуем новые технологии и решения для повышения эффективности, сокращения воздействия на окружающую среду и расширения спектра наших услуг. Будь то внедрение передового программного обеспечения для отслеживания, использование электротранспорта для устойчивой логистики или автоматизация процессов, наша компания всегда открыта для новых идей, способствующих прогрессу.",
            
            associations_about: "Сотрудничество",
            associations_short: "MMSH Logistics сотрудничает с мировыми лидерами для предоставления первоклассных логистических решений.",
            associations_full: "MMSH Logistics тесно сотрудничает с ведущими мировыми компаниями, чтобы предоставлять передовые логистические услуги. Наши стратегические партнерства расширяют наши международные возможности, обеспечивая эффективные транспортные решения, адаптированные под потребности наших клиентов. С акцентом на надежность и высокие стандарты мы укрепляем свою репутацию как доверенный логистический партнер по всему миру.",
            
            forward_thinking: "Дальновидность",
            forward_thinking_short: "Наша компания ориентирована на рост, инновации и глобальную экспансию.",
            forward_thinking_full: "Наша компания сосредоточена на долгосрочном росте и постоянном улучшении. Мы расширяем свои операции и инвестируем в новые технологии, чтобы улучшить качество предоставляемых услуг. Наши будущие планы включают расширение международного присутствия, внедрение устойчивых методов и разработку инновационных решений, которые будут способствовать развитию логистической отрасли.",                 
        // About page
        // Messages
            fetch_error: "Не удалось загрузить сообщения",
            confirm_delete: "Вы уверены, что хотите удалить это сообщение?",
            delete_error: "Не удалось удалить сообщение",
            delete_error_log: "Ошибка при удалении сообщения:",
            question: "Вопрос",
            no_messages: "Сообщения не найдены.",          
        // Messages
        // Contacts
            Search_contacts: "Поиск контактов...",
            Contacts: "Контакты",
            Add_Contact: "Добавить контакт",
            Please: "Пожалуйста, не делитесь контактами",
            Save: "Сохранить",
            Username: "Имя пользователя",
            Phone_1: "Телефон 1",
            Phone_2: "Телефон 2 (необязательно)",
            edit: "Редактировать контакт",
            delete: "Удалить контакт",        
        // Contacts
        // History
        birth_title: "Рождение MMSH Logistics",
        birth_text: "В 2019 году три дальновидных брата — Минходжидин, МухаммадАли и Шукурилло — основали компанию MMSH Logistics. Они мечтали создать логистическую компанию, которая могла бы соединять бизнесы по всему миру.",
        challenges_title: "Вызовы и настойчивость",
        challenges_text: "Создание логистической компании было непростым делом. Они столкнулись с многочисленными финансовыми трудностями, операционными препятствиями и необходимостью завоевать доверие в конкурентной среде. Но их преданность делу и тяжелый труд никогда не ослабевали.",
        expand_title: "Расширение горизонтов",
        expand_text: "Несмотря на трудности, MMSH Logistics быстро развивалась. Формируя стратегические партнерства и постоянно улучшая свои услуги, они начали сотрудничать с предприятиями в разных странах мира.",
        global_title: "Выход на международный уровень",
        global_text: "Сегодня MMSH Logistics сотрудничает с 34 странами Европы, Азии и других регионов. Их глобальное присутствие свидетельствует об их приверженности к логистическому совершенству.",
        career_title: "Создание возможностей для карьеры",
        career_text: "MMSH Logistics — это не только транспорт. Это платформа для молодых и талантливых специалистов, предлагающая карьерные возможности в сфере управления, маркетинга, IT и многоязычного общения.",
        future_title: "Будущее MMSH Logistics",
        future_text: "Благодаря инновациям, сильному лидерству и страсти к логистике, MMSH Logistics продолжает расти. Будущее сулит еще больше возможностей для расширения и трансформации на мировом рынке.",
        click_text: "Нажмите на эту книгу, чтобы узнать больше о истории MMSH",
        // History

    }
};

export default ru;
